// extracted by mini-css-extract-plugin
module.exports = {"when":"style-module_when__hLEjkYCt2pQro92HcuTu"};